import cx from 'classnames'
import { useTranslations } from 'next-intl'
import Image from 'next/image'

import { useAppDispatch } from '@/utils/useAppDispatch'

import { setOverlayView } from '../overlay/overlaySlice'

import SCLogo from 'assets/images/logos/supercell-id-white.svg'

import styles from './LoginButton.module.scss'

interface LoginButtonProps {
  additionalClasses?: string
  onClick?: () => void
  'data-cy'?: string
}
export const LoginButton: React.FC<LoginButtonProps> = ({ additionalClasses, onClick, 'data-cy': dataCy }) => {
  const dispatch = useAppDispatch()
  const t = useTranslations()

  return (
    <button
      className={cx(styles.LoginButton, additionalClasses)}
      onClick={() => {
        dispatch(setOverlayView({ view: { type: 'LOGIN' } }))
        onClick?.()
      }}
      data-cy={dataCy}
    >
      <span className={styles.LoginText}>{t('login_title')}</span>
      <div className={styles.IdLogo}>
        <Image alt="logo" src={SCLogo} layout="fill" objectFit="contain" sizes="5vw" quality={100} />
      </div>
    </button>
  )
}
